import {
  GET_WORKGROUPDETAIL,
  GET_WORKGROUPDETAIL_SUCCESS,
  GET_WORKGROUPDETAIL_FAIL,
  DELETE_WORKGROUPDETAIL,
  DELETE_WORKGROUPDETAIL_SUCCESS,
  DELETE_WORKGROUPDETAIL_FAIL,
  UPDATE_WORKGROUPDETAIL,
  UPDATE_WORKGROUPDETAIL_SUCCESS,
  UPDATE_WORKGROUPDETAIL_FAIL,
  ADD_NEW_WORKGROUPDETAIL,
  ADD_WORKGROUPDETAIL_SUCCESS,
  ADD_WORKGROUPDETAIL_FAIL,
  WORKGROUPDETAIL_LOADING,
  WORKGROUPDETAIL_RESET,
} from "./actionType";

export const resetWorkGroupDetailState = (actionType) => ({
  type: WORKGROUPDETAIL_RESET,
  payload: { actionType },
});

export const getWorkGroupDetailSuccess = (actionType, data) => ({
  type: GET_WORKGROUPDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getWorkGroupDetailFail = (actionType, error) => ({
  type: GET_WORKGROUPDETAIL_FAIL,
  payload: { actionType, error },
});

export const getWorkGroupDetail = data => ({
  type: GET_WORKGROUPDETAIL,
  payload: data,
});

export const getWorkGroupDetailLoading = () => ({
  type: WORKGROUPDETAIL_LOADING
});

export const deleteWorkGroupDetail = data => ({
  type: DELETE_WORKGROUPDETAIL,
  payload: data,
});

export const deleteWorkGroupDetailSuccess = data => ({
  type: DELETE_WORKGROUPDETAIL_SUCCESS,
  payload: data,
});

export const deleteWorkGroupDetailFail = error => ({
  type: DELETE_WORKGROUPDETAIL_FAIL,
  payload: error,
});

export const updateWorkGroupDetail = data => ({
  type: UPDATE_WORKGROUPDETAIL,
  payload: data,
});

export const updateWorkGroupDetailFail = error => ({
  type: UPDATE_WORKGROUPDETAIL_FAIL,
  payload: error,
});

export const updateWorkGroupDetailSuccess = data => ({
  type: UPDATE_WORKGROUPDETAIL_SUCCESS,
  payload: data,
});

export const addNewWorkGroupDetail = data => ({
  type: ADD_NEW_WORKGROUPDETAIL,
  payload: data,
});

export const addWorkGroupDetailSuccess = data => ({
  type: ADD_WORKGROUPDETAIL_SUCCESS,
  payload: data,
});

export const addWorkGroupDetailFail = error => ({
  type: ADD_WORKGROUPDETAIL_FAIL,
  payload: error,
});